import * as WSUtils from './Source/CloudStudio.Utils.WebServices';
import { ApolusTypes } from './CloudStudio.Core.Gear.Apolus.Types';
import { CoreTypes } from 'common-cloudstudio';

export module CloudStudio.Apolus.Services.Proxies {

  import ServiceException = WSUtils.CloudStudio.Utils.WebServices.ServiceException;
  import WebServiceProxy = WSUtils.CloudStudio.Utils.WebServices.WebServiceProxy;

  // Method in/out messages
  class PingMessageIn {
  }

  class CreateClientMessageIn {
    public accessToken: string;
    public client: ApolusTypes.Client;
  }

  class CreateClientMessageOut {
    public CreateClientResult: ApolusTypes.Client;
  }

  class CreateClientExtendedMessageIn {
    public accessToken: string;
    public client: ApolusTypes.ClientExtended;
  }

  class CreateClientExtendedMessageOut {
    public CreateClientExtendedResult: ApolusTypes.ClientExtended;
  }

  class CreateClientExtendedsMessageIn {
    public accessToken: string;
    public clientextendeds: ApolusTypes.ClientExtended[];
  }

  class CreateClientExtendedsMessageOut {
    public CreateClientExtendedsResult: ApolusTypes.BulkClientExtendedCreation;
  }

  class CreateClientMassExtendedMessageIn {
    public accessToken: string;
    public client: ApolusTypes.ClientMassExtended;
  }

  class CreateClientMassExtendedMessageOut {
    public CreateClientMassExtendedResult: ApolusTypes.ClientMassExtended;
  }

  class CreateClientsMessageIn {
    public accessToken: string;
    public clients: ApolusTypes.Client[];
  }

  class CreateClientsMessageOut {
    public CreateClientsResult: ApolusTypes.BulkClientCreation;
  }

  class DeleteClientMessageIn {
    public accessToken: string;
    public clientID: number;
  }

  class DeleteClientMessageOut {
    public DeleteClientResult: number;
  }

  class EditClientMessageIn {
    public accessToken: string;
    public client: ApolusTypes.Client;
  }

  class EditClientMessageOut {
    public EditClientResult: ApolusTypes.Client;
  }

  class EnumClientByAddressIDMessageIn {
    public accessToken: string;
    public addressID: number;
  }

  class EnumClientByAddressIDMessageOut {
    public EnumClientByAddressIDResult: ApolusTypes.Client[];
  }

  class EnumClientByClientIDMessageIn {
    public accessToken: string;
    public emailID: number;
  }

  class EnumClientByClientIDMessageOut {
    public EnumClientByClientIDResult: ApolusTypes.Client[];
  }

  class EnumClientByEmailMessageIn {
    public accessToken: string;
    public email: string;
  }

  class EnumClientByEmailMessageOut {
    public EnumClientByEmailResult: ApolusTypes.Client[];
  }

  class EnumClientByExternalIDMessageIn {
    public accessToken: string;
    public externalID: string;
  }

  class EnumClientByExternalIDMessageOut {
    public EnumClientByExternalIDResult: ApolusTypes.Client[];
  }

  class EnumClientByFacilityIDMessageIn {
    public accessToken: string;
    public facilityID: number;
  }

  class EnumClientByFacilityIDMessageOut {
    public EnumClientByFacilityIDResult: ApolusTypes.Client[];
  }

  class EnumClientByIDsMessageIn {
    public accessToken: string;
    public clientIDs: number[];
  }

  class EnumClientByIDsMessageOut {
    public EnumClientByIDsResult: ApolusTypes.Client[];
  }

  class EnumClientByPhoneNumberMessageIn {
    public accessToken: string;
    public phonenumber: string;
  }

  class EnumClientByPhoneNumberMessageOut {
    public EnumClientByPhoneNumberResult: ApolusTypes.Client[];
  }

  class EnumClientsMessageIn {
    public accessToken: string;
  }

  class EnumClientsMessageOut {
    public EnumClientsResult: ApolusTypes.Client[];
  }

  class GetClientMessageIn {
    public accessToken: string;
    public clientID: number;
  }

  class GetClientMessageOut {
    public GetClientResult: ApolusTypes.Client;
  }

  class CreateContractMessageIn {
    public accessToken: string;
    public contract: ApolusTypes.Contract;
  }

  class CreateContractMessageOut {
    public CreateContractResult: ApolusTypes.Contract;
  }

  class CreateContractExtendedMessageIn {
    public accessToken: string;
    public contract: ApolusTypes.ContractExtended;
  }

  class CreateContractExtendedMessageOut {
    public CreateContractExtendedResult: ApolusTypes.ContractExtended;
  }

  class CreateContractExtendedsMessageIn {
    public accessToken: string;
    public contractextendeds: ApolusTypes.ContractExtended[];
  }

  class CreateContractExtendedsMessageOut {
    public CreateContractExtendedsResult: ApolusTypes.BulkContractExtendedCreation;
  }

  class CreateContractsMessageIn {
    public accessToken: string;
    public contracts: ApolusTypes.Contract[];
  }

  class CreateContractsMessageOut {
    public CreateContractsResult: ApolusTypes.BulkContractCreation;
  }

  class DeleteContractMessageIn {
    public accessToken: string;
    public contractID: number;
    public deletedByAccountID: number;
  }

  class DeleteContractMessageOut {
    public DeleteContractResult: number;
  }

  class EditContractMessageIn {
    public accessToken: string;
    public contract: ApolusTypes.Contract;
  }

  class EditContractMessageOut {
    public EditContractResult: ApolusTypes.Contract;
  }

  class EnumContractByClientExternalIDMessageIn {
    public accessToken: string;
    public clientExternalID: string;
  }

  class EnumContractByClientExternalIDMessageOut {
    public EnumContractByClientExternalIDResult: ApolusTypes.Contract[];
  }

  class EnumContractByClientIDMessageIn {
    public accessToken: string;
    public clientID: number;
  }

  class EnumContractByClientIDMessageOut {
    public EnumContractByClientIDResult: ApolusTypes.Contract[];
  }

  class EnumContractByDeviceIDMessageIn {
    public accessToken: string;
    public deviceID: number;
  }

  class EnumContractByDeviceIDMessageOut {
    public EnumContractByDeviceIDResult: ApolusTypes.Contract[];
  }

  class EnumContractByIDsMessageIn {
    public accessToken: string;
    public contractIDs: number[];
  }

  class EnumContractByIDsMessageOut {
    public EnumContractByIDsResult: ApolusTypes.Contract[];
  }

  class EnumContractsMessageIn {
    public accessToken: string;
  }

  class EnumContractsMessageOut {
    public EnumContractsResult: ApolusTypes.Contract[];
  }

  class EnumDevicesAllowedForContractsMessageIn {
    public accessToken: string;
    public facilityID: number;
  }

  class EnumDevicesAllowedForContractsMessageOut {
    public EnumDevicesAllowedForContractsResult: CoreTypes.Device[];
  }

  class EnumEndpointsAllowedForContractsMessageIn {
    public accessToken: string;
    public facilityID: number;
    public deviceID: number | null;
  }

  class EnumEndpointsAllowedForContractsMessageOut {
    public EnumEndpointsAllowedForContractsResult: CoreTypes.Endpoint[];
  }

  class EnumEndpointTypesAllowedForContractsMessageIn {
    public accessToken: string;
  }

  class EnumEndpointTypesAllowedForContractsMessageOut {
    public EnumEndpointTypesAllowedForContractsResult: CoreTypes.EndpointType[];
  }

  class GetContractMessageIn {
    public accessToken: string;
    public contractID: number;
  }

  class GetContractMessageOut {
    public GetContractResult: ApolusTypes.Contract;
  }

  class CreateGeocoding_AddressesMessageIn {
    public accessToken: string;
    public geocoding_addresses: ApolusTypes.GeocodingAddress[];
  }

  class CreateGeocoding_AddressesMessageOut {
    public CreateGeocoding_AddressesResult: ApolusTypes.BulkGeocodingAddressCreation;
  }

  class CreateGeocodingAddressMessageIn {
    public accessToken: string;
    public address: ApolusTypes.GeocodingAddress;
  }

  class CreateGeocodingAddressMessageOut {
    public CreateGeocodingAddressResult: number;
  }

  class DeleteGeocodingAddressMessageIn {
    public accessToken: string;
    public addressID: number;
  }

  class DeleteGeocodingAddressMessageOut {
    public DeleteGeocodingAddressResult: number;
  }

  class EditGeocodingAddressMessageIn {
    public accessToken: string;
    public address: ApolusTypes.GeocodingAddress;
  }

  class EditGeocodingAddressMessageOut {
    public EditGeocodingAddressResult: ApolusTypes.GeocodingAddress;
  }

  class EnumGeocodingAddressByIDsMessageIn {
    public accessToken: string;
    public addressIDs: number[];
  }

  class EnumGeocodingAddressByIDsMessageOut {
    public EnumGeocodingAddressByIDsResult: ApolusTypes.GeocodingAddress[];
  }

  class EnumGeocodingAddressesMessageIn {
    public accessToken: string;
  }

  class EnumGeocodingAddressesMessageOut {
    public EnumGeocodingAddressesResult: ApolusTypes.GeocodingAddress[];
  }

  class GetGeocodingAddressMessageIn {
    public accessToken: string;
    public addressID: number;
  }

  class GetGeocodingAddressMessageOut {
    public GetGeocodingAddressResult: ApolusTypes.GeocodingAddress;
  }

  class HideGeocodingAddressMessageIn {
    public accessToken: string;
    public addressID: number;
  }

  class HideGeocodingAddressMessageOut {
    public HideGeocodingAddressResult: number;
  }

  class ResolveGeocodingTextMessageIn {
    public accessToken: string;
    public text: string[];
  }

  class ResolveGeocodingTextMessageOut {
    public ResolveGeocodingTextResult: ApolusTypes.ResolvedGeocodingAddress[];
  }

  class CreateRateMessageIn {
    public accessToken: string;
    public description: string;
  }

  class CreateRateMessageOut {
    public CreateRateResult: number;
  }

  class CreateRatesMessageIn {
    public accessToken: string;
    public rates: ApolusTypes.Rate[];
  }

  class CreateRatesMessageOut {
    public CreateRatesResult: ApolusTypes.BulkRateCreation;
  }

  class DeleteRateMessageIn {
    public accessToken: string;
    public rateID: number;
  }

  class DeleteRateMessageOut {
    public DeleteRateResult: number;
  }

  class EditRateMessageIn {
    public accessToken: string;
    public rate: ApolusTypes.Rate;
  }

  class EditRateMessageOut {
    public EditRateResult: ApolusTypes.Rate;
  }

  class EnumRateByIDsMessageIn {
    public accessToken: string;
    public rateIDs: number[];
  }

  class EnumRateByIDsMessageOut {
    public EnumRateByIDsResult: ApolusTypes.Rate[];
  }

  class EnumRatesMessageIn {
    public accessToken: string;
  }

  class EnumRatesMessageOut {
    public EnumRatesResult: ApolusTypes.Rate[];
  }

  class GetRateMessageIn {
    public accessToken: string;
    public rateID: number;
  }

  class GetRateMessageOut {
    public GetRateResult: ApolusTypes.Rate;
  }

  class HideRateMessageIn {
    public accessToken: string;
    public rateID: number;
  }

  class HideRateMessageOut {
    public HideRateResult: number;
  }

  class CreateSectorMessageIn {
    public accessToken: string;
    public description: string;
  }

  class CreateSectorMessageOut {
    public CreateSectorResult: number;
  }

  class CreateSectorsMessageIn {
    public accessToken: string;
    public sectors: ApolusTypes.Sector[];
  }

  class CreateSectorsMessageOut {
    public CreateSectorsResult: ApolusTypes.BulkSectorCreation;
  }

  class DeleteSectorMessageIn {
    public accessToken: string;
    public sectorID: number;
  }

  class DeleteSectorMessageOut {
    public DeleteSectorResult: number;
  }

  class EditSectorMessageIn {
    public accessToken: string;
    public sector: ApolusTypes.Sector;
  }

  class EditSectorMessageOut {
    public EditSectorResult: ApolusTypes.Sector;
  }

  class EnumSectorByIDsMessageIn {
    public accessToken: string;
    public sectorIDs: number[];
  }

  class EnumSectorByIDsMessageOut {
    public EnumSectorByIDsResult: ApolusTypes.Sector[];
  }

  class EnumSectorsMessageIn {
    public accessToken: string;
  }

  class EnumSectorsMessageOut {
    public EnumSectorsResult: ApolusTypes.Sector[];
  }

  class GetSectorMessageIn {
    public accessToken: string;
    public sectorID: number;
  }

  class GetSectorMessageOut {
    public GetSectorResult: ApolusTypes.Sector;
  }

  class HideSectorMessageIn {
    public accessToken: string;
    public sectorID: number;
  }

  class HideSectorMessageOut {
    public HideSectorResult: number;
  }

  class GetMasterEntityContentMessageIn {
    public accessToken: string;
    public clientID: number;
    public entityType: ApolusTypes.ApolusMasterEntityType;
  }

  class GetMasterEntityContentMessageOut {
    public GetMasterEntityContentResult: CoreTypes.MasterEntityDataContent;
  }

  class GetDashboardMessageIn {
    public accessToken: string;
    public facilityID: number;
    public adminArea2: number | null;
    public sectorID: number | null;
    public rateID: number | null;
    public fromDateTime: CoreTypes.DateTimeDT;
    public toDateTime: CoreTypes.DateTimeDT;
  }

  class GetDashboardMessageOut {
    public GetDashboardResult: ApolusTypes.Dashboard;
  }

  class GetUserDashboardMessageIn {
    public accessToken: string;
    public contractID: number;
    public fromDateTime: CoreTypes.DateTimeDT;
    public toDateTime: CoreTypes.DateTimeDT;
  }

  class GetUserDashboardMessageOut {
    public GetUserDashboardResult: ApolusTypes.UserDashboard;
  }

  class GetApolusLiteralsMessageIn {
    public accessToken: string;
  }

  class GetApolusLiteralsMessageOut {
    public GetApolusLiteralsResult: ApolusTypes.ApolusCommonLiterals;
  }

  class DataTypesDummyMessageIn {
    public p1: ApolusTypes.ApolusMenuHierarchyItem;
    public p2: ApolusTypes.ApolusCommonLiterals;
  }

  export class ApolusServiceProxy extends WebServiceProxy {

    // Web methods
    public Ping(successFunc: () => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new PingMessageIn();
      this.SendRequest('Ping', InP,
        function(content: object) {
          successFunc();
        },
        errorFunc
      );
    }

    public CreateClient(accessToken: string, client: ApolusTypes.Client, successFunc: (result: ApolusTypes.Client) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateClientMessageIn();
      InP.accessToken = accessToken;
      InP.client = client;
      this.SendRequest('CreateClient', InP,
        function(content: object) {
          const data = content as CreateClientMessageOut;
          successFunc(data.CreateClientResult);
        },
        errorFunc
      );
    }

    public CreateClientExtended(accessToken: string, client: ApolusTypes.ClientExtended, successFunc: (result: ApolusTypes.ClientExtended) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateClientExtendedMessageIn();
      InP.accessToken = accessToken;
      InP.client = client;
      this.SendRequest('CreateClientExtended', InP,
        function(content: object) {
          const data = content as CreateClientExtendedMessageOut;
          successFunc(data.CreateClientExtendedResult);
        },
        errorFunc
      );
    }

    public CreateClientExtendeds(accessToken: string, clientextendeds: ApolusTypes.ClientExtended[], successFunc: (result: ApolusTypes.BulkClientExtendedCreation) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateClientExtendedsMessageIn();
      InP.accessToken = accessToken;
      InP.clientextendeds = clientextendeds;
      this.SendRequest('CreateClientExtendeds', InP,
        function(content: object) {
          const data = content as CreateClientExtendedsMessageOut;
          successFunc(data.CreateClientExtendedsResult);
        },
        errorFunc
      );
    }

    public CreateClientMassExtended(accessToken: string, client: ApolusTypes.ClientMassExtended, successFunc: (result: ApolusTypes.ClientMassExtended) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateClientMassExtendedMessageIn();
      InP.accessToken = accessToken;
      InP.client = client;
      this.SendRequest('CreateClientMassExtended', InP,
        function(content: object) {
          const data = content as CreateClientMassExtendedMessageOut;
          successFunc(data.CreateClientMassExtendedResult);
        },
        errorFunc
      );
    }

    public CreateClients(accessToken: string, clients: ApolusTypes.Client[], successFunc: (result: ApolusTypes.BulkClientCreation) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateClientsMessageIn();
      InP.accessToken = accessToken;
      InP.clients = clients;
      this.SendRequest('CreateClients', InP,
        function(content: object) {
          const data = content as CreateClientsMessageOut;
          successFunc(data.CreateClientsResult);
        },
        errorFunc
      );
    }

    public DeleteClient(accessToken: string, clientID: number, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new DeleteClientMessageIn();
      InP.accessToken = accessToken;
      InP.clientID = clientID;
      this.SendRequest('DeleteClient', InP,
        function(content: object) {
          const data = content as DeleteClientMessageOut;
          successFunc(data.DeleteClientResult);
        },
        errorFunc
      );
    }

    public EditClient(accessToken: string, client: ApolusTypes.Client, successFunc: (result: ApolusTypes.Client) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EditClientMessageIn();
      InP.accessToken = accessToken;
      InP.client = client;
      this.SendRequest('EditClient', InP,
        function(content: object) {
          const data = content as EditClientMessageOut;
          successFunc(data.EditClientResult);
        },
        errorFunc
      );
    }

    public EnumClientByAddressID(accessToken: string, addressID: number, successFunc: (result: ApolusTypes.Client[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumClientByAddressIDMessageIn();
      InP.accessToken = accessToken;
      InP.addressID = addressID;
      this.SendRequest('EnumClientByAddressID', InP,
        function(content: object) {
          const data = content as EnumClientByAddressIDMessageOut;
          successFunc(data.EnumClientByAddressIDResult);
        },
        errorFunc
      );
    }

    public EnumClientByClientID(accessToken: string, emailID: number, successFunc: (result: ApolusTypes.Client[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumClientByClientIDMessageIn();
      InP.accessToken = accessToken;
      InP.emailID = emailID;
      this.SendRequest('EnumClientByClientID', InP,
        function(content: object) {
          const data = content as EnumClientByClientIDMessageOut;
          successFunc(data.EnumClientByClientIDResult);
        },
        errorFunc
      );
    }

    public EnumClientByEmail(accessToken: string, email: string, successFunc: (result: ApolusTypes.Client[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumClientByEmailMessageIn();
      InP.accessToken = accessToken;
      InP.email = email;
      this.SendRequest('EnumClientByEmail', InP,
        function(content: object) {
          const data = content as EnumClientByEmailMessageOut;
          successFunc(data.EnumClientByEmailResult);
        },
        errorFunc
      );
    }

    public EnumClientByExternalID(accessToken: string, externalID: string, successFunc: (result: ApolusTypes.Client[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumClientByExternalIDMessageIn();
      InP.accessToken = accessToken;
      InP.externalID = externalID;
      this.SendRequest('EnumClientByExternalID', InP,
        function(content: object) {
          const data = content as EnumClientByExternalIDMessageOut;
          successFunc(data.EnumClientByExternalIDResult);
        },
        errorFunc
      );
    }

    public EnumClientByFacilityID(accessToken: string, facilityID: number, successFunc: (result: ApolusTypes.Client[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumClientByFacilityIDMessageIn();
      InP.accessToken = accessToken;
      InP.facilityID = facilityID;
      this.SendRequest('EnumClientByFacilityID', InP,
        function(content: object) {
          const data = content as EnumClientByFacilityIDMessageOut;
          successFunc(data.EnumClientByFacilityIDResult);
        },
        errorFunc
      );
    }

    public EnumClientByIDs(accessToken: string, clientIDs: number[], successFunc: (result: ApolusTypes.Client[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumClientByIDsMessageIn();
      InP.accessToken = accessToken;
      InP.clientIDs = clientIDs;
      this.SendRequest('EnumClientByIDs', InP,
        function(content: object) {
          const data = content as EnumClientByIDsMessageOut;
          successFunc(data.EnumClientByIDsResult);
        },
        errorFunc
      );
    }

    public EnumClientByPhoneNumber(accessToken: string, phonenumber: string, successFunc: (result: ApolusTypes.Client[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumClientByPhoneNumberMessageIn();
      InP.accessToken = accessToken;
      InP.phonenumber = phonenumber;
      this.SendRequest('EnumClientByPhoneNumber', InP,
        function(content: object) {
          const data = content as EnumClientByPhoneNumberMessageOut;
          successFunc(data.EnumClientByPhoneNumberResult);
        },
        errorFunc
      );
    }

    public EnumClients(accessToken: string, successFunc: (result: ApolusTypes.Client[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumClientsMessageIn();
      InP.accessToken = accessToken;
      this.SendRequest('EnumClients', InP,
        function(content: object) {
          const data = content as EnumClientsMessageOut;
          successFunc(data.EnumClientsResult);
        },
        errorFunc
      );
    }

    public GetClient(accessToken: string, clientID: number, successFunc: (result: ApolusTypes.Client) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new GetClientMessageIn();
      InP.accessToken = accessToken;
      InP.clientID = clientID;
      this.SendRequest('GetClient', InP,
        function(content: object) {
          const data = content as GetClientMessageOut;
          successFunc(data.GetClientResult);
        },
        errorFunc
      );
    }

    public CreateContract(accessToken: string, contract: ApolusTypes.Contract, successFunc: (result: ApolusTypes.Contract) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateContractMessageIn();
      InP.accessToken = accessToken;
      InP.contract = contract;
      this.SendRequest('CreateContract', InP,
        function(content: object) {
          const data = content as CreateContractMessageOut;
          successFunc(data.CreateContractResult);
        },
        errorFunc
      );
    }

    public CreateContractExtended(accessToken: string, contract: ApolusTypes.ContractExtended, successFunc: (result: ApolusTypes.ContractExtended) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateContractExtendedMessageIn();
      InP.accessToken = accessToken;
      InP.contract = contract;
      this.SendRequest('CreateContractExtended', InP,
        function(content: object) {
          const data = content as CreateContractExtendedMessageOut;
          successFunc(data.CreateContractExtendedResult);
        },
        errorFunc
      );
    }

    public CreateContractExtendeds(accessToken: string, contractextendeds: ApolusTypes.ContractExtended[], successFunc: (result: ApolusTypes.BulkContractExtendedCreation) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateContractExtendedsMessageIn();
      InP.accessToken = accessToken;
      InP.contractextendeds = contractextendeds;
      this.SendRequest('CreateContractExtendeds', InP,
        function(content: object) {
          const data = content as CreateContractExtendedsMessageOut;
          successFunc(data.CreateContractExtendedsResult);
        },
        errorFunc
      );
    }

    public CreateContracts(accessToken: string, contracts: ApolusTypes.Contract[], successFunc: (result: ApolusTypes.BulkContractCreation) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateContractsMessageIn();
      InP.accessToken = accessToken;
      InP.contracts = contracts;
      this.SendRequest('CreateContracts', InP,
        function(content: object) {
          const data = content as CreateContractsMessageOut;
          successFunc(data.CreateContractsResult);
        },
        errorFunc
      );
    }

    public DeleteContract(accessToken: string, contractID: number, deletedByAccountID: number, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new DeleteContractMessageIn();
      InP.accessToken = accessToken;
      InP.contractID = contractID;
      InP.deletedByAccountID = deletedByAccountID;
      this.SendRequest('DeleteContract', InP,
        function(content: object) {
          const data = content as DeleteContractMessageOut;
          successFunc(data.DeleteContractResult);
        },
        errorFunc
      );
    }

    public EditContract(accessToken: string, contract: ApolusTypes.Contract, successFunc: (result: ApolusTypes.Contract) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EditContractMessageIn();
      InP.accessToken = accessToken;
      InP.contract = contract;
      this.SendRequest('EditContract', InP,
        function(content: object) {
          const data = content as EditContractMessageOut;
          successFunc(data.EditContractResult);
        },
        errorFunc
      );
    }

    public EnumContractByClientExternalID(accessToken: string, clientExternalID: string, successFunc: (result: ApolusTypes.Contract[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumContractByClientExternalIDMessageIn();
      InP.accessToken = accessToken;
      InP.clientExternalID = clientExternalID;
      this.SendRequest('EnumContractByClientExternalID', InP,
        function(content: object) {
          const data = content as EnumContractByClientExternalIDMessageOut;
          successFunc(data.EnumContractByClientExternalIDResult);
        },
        errorFunc
      );
    }

    public EnumContractByClientID(accessToken: string, clientID: number, successFunc: (result: ApolusTypes.Contract[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumContractByClientIDMessageIn();
      InP.accessToken = accessToken;
      InP.clientID = clientID;
      this.SendRequest('EnumContractByClientID', InP,
        function(content: object) {
          const data = content as EnumContractByClientIDMessageOut;
          successFunc(data.EnumContractByClientIDResult);
        },
        errorFunc
      );
    }

    public EnumContractByDeviceID(accessToken: string, deviceID: number, successFunc: (result: ApolusTypes.Contract[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumContractByDeviceIDMessageIn();
      InP.accessToken = accessToken;
      InP.deviceID = deviceID;
      this.SendRequest('EnumContractByDeviceID', InP,
        function(content: object) {
          const data = content as EnumContractByDeviceIDMessageOut;
          successFunc(data.EnumContractByDeviceIDResult);
        },
        errorFunc
      );
    }

    public EnumContractByIDs(accessToken: string, contractIDs: number[], successFunc: (result: ApolusTypes.Contract[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumContractByIDsMessageIn();
      InP.accessToken = accessToken;
      InP.contractIDs = contractIDs;
      this.SendRequest('EnumContractByIDs', InP,
        function(content: object) {
          const data = content as EnumContractByIDsMessageOut;
          successFunc(data.EnumContractByIDsResult);
        },
        errorFunc
      );
    }

    public EnumContracts(accessToken: string, successFunc: (result: ApolusTypes.Contract[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumContractsMessageIn();
      InP.accessToken = accessToken;
      this.SendRequest('EnumContracts', InP,
        function(content: object) {
          const data = content as EnumContractsMessageOut;
          successFunc(data.EnumContractsResult);
        },
        errorFunc
      );
    }

    public EnumDevicesAllowedForContracts(accessToken: string, facilityID: number, successFunc: (result: CoreTypes.Device[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumDevicesAllowedForContractsMessageIn();
      InP.accessToken = accessToken;
      InP.facilityID = facilityID;
      this.SendRequest('EnumDevicesAllowedForContracts', InP,
        function(content: object) {
          const data = content as EnumDevicesAllowedForContractsMessageOut;
          successFunc(data.EnumDevicesAllowedForContractsResult);
        },
        errorFunc
      );
    }

    public EnumEndpointsAllowedForContracts(accessToken: string, facilityID: number, deviceID: number | null, successFunc: (result: CoreTypes.Endpoint[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumEndpointsAllowedForContractsMessageIn();
      InP.accessToken = accessToken;
      InP.facilityID = facilityID;
      InP.deviceID = deviceID;
      this.SendRequest('EnumEndpointsAllowedForContracts', InP,
        function(content: object) {
          const data = content as EnumEndpointsAllowedForContractsMessageOut;
          successFunc(data.EnumEndpointsAllowedForContractsResult);
        },
        errorFunc
      );
    }

    public EnumEndpointTypesAllowedForContracts(accessToken: string, successFunc: (result: CoreTypes.EndpointType[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumEndpointTypesAllowedForContractsMessageIn();
      InP.accessToken = accessToken;
      this.SendRequest('EnumEndpointTypesAllowedForContracts', InP,
        function(content: object) {
          const data = content as EnumEndpointTypesAllowedForContractsMessageOut;
          successFunc(data.EnumEndpointTypesAllowedForContractsResult);
        },
        errorFunc
      );
    }

    public GetContract(accessToken: string, contractID: number, successFunc: (result: ApolusTypes.Contract) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new GetContractMessageIn();
      InP.accessToken = accessToken;
      InP.contractID = contractID;
      this.SendRequest('GetContract', InP,
        function(content: object) {
          const data = content as GetContractMessageOut;
          successFunc(data.GetContractResult);
        },
        errorFunc
      );
    }

    public CreateGeocoding_Addresses(accessToken: string, geocoding_addresses: ApolusTypes.GeocodingAddress[], successFunc: (result: ApolusTypes.BulkGeocodingAddressCreation) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateGeocoding_AddressesMessageIn();
      InP.accessToken = accessToken;
      InP.geocoding_addresses = geocoding_addresses;
      this.SendRequest('CreateGeocoding_Addresses', InP,
        function(content: object) {
          const data = content as CreateGeocoding_AddressesMessageOut;
          successFunc(data.CreateGeocoding_AddressesResult);
        },
        errorFunc
      );
    }

    public CreateGeocodingAddress(accessToken: string, address: ApolusTypes.GeocodingAddress, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateGeocodingAddressMessageIn();
      InP.accessToken = accessToken;
      InP.address = address;
      this.SendRequest('CreateGeocodingAddress', InP,
        function(content: object) {
          const data = content as CreateGeocodingAddressMessageOut;
          successFunc(data.CreateGeocodingAddressResult);
        },
        errorFunc
      );
    }

    public DeleteGeocodingAddress(accessToken: string, addressID: number, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new DeleteGeocodingAddressMessageIn();
      InP.accessToken = accessToken;
      InP.addressID = addressID;
      this.SendRequest('DeleteGeocodingAddress', InP,
        function(content: object) {
          const data = content as DeleteGeocodingAddressMessageOut;
          successFunc(data.DeleteGeocodingAddressResult);
        },
        errorFunc
      );
    }

    public EditGeocodingAddress(accessToken: string, address: ApolusTypes.GeocodingAddress, successFunc: (result: ApolusTypes.GeocodingAddress) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EditGeocodingAddressMessageIn();
      InP.accessToken = accessToken;
      InP.address = address;
      this.SendRequest('EditGeocodingAddress', InP,
        function(content: object) {
          const data = content as EditGeocodingAddressMessageOut;
          successFunc(data.EditGeocodingAddressResult);
        },
        errorFunc
      );
    }

    public EnumGeocodingAddressByIDs(accessToken: string, addressIDs: number[], successFunc: (result: ApolusTypes.GeocodingAddress[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumGeocodingAddressByIDsMessageIn();
      InP.accessToken = accessToken;
      InP.addressIDs = addressIDs;
      this.SendRequest('EnumGeocodingAddressByIDs', InP,
        function(content: object) {
          const data = content as EnumGeocodingAddressByIDsMessageOut;
          successFunc(data.EnumGeocodingAddressByIDsResult);
        },
        errorFunc
      );
    }

    public EnumGeocodingAddresses(accessToken: string, successFunc: (result: ApolusTypes.GeocodingAddress[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumGeocodingAddressesMessageIn();
      InP.accessToken = accessToken;
      this.SendRequest('EnumGeocodingAddresses', InP,
        function(content: object) {
          const data = content as EnumGeocodingAddressesMessageOut;
          successFunc(data.EnumGeocodingAddressesResult);
        },
        errorFunc
      );
    }

    public GetGeocodingAddress(accessToken: string, addressID: number, successFunc: (result: ApolusTypes.GeocodingAddress) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new GetGeocodingAddressMessageIn();
      InP.accessToken = accessToken;
      InP.addressID = addressID;
      this.SendRequest('GetGeocodingAddress', InP,
        function(content: object) {
          const data = content as GetGeocodingAddressMessageOut;
          successFunc(data.GetGeocodingAddressResult);
        },
        errorFunc
      );
    }

    public HideGeocodingAddress(accessToken: string, addressID: number, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new HideGeocodingAddressMessageIn();
      InP.accessToken = accessToken;
      InP.addressID = addressID;
      this.SendRequest('HideGeocodingAddress', InP,
        function(content: object) {
          const data = content as HideGeocodingAddressMessageOut;
          successFunc(data.HideGeocodingAddressResult);
        },
        errorFunc
      );
    }

    public ResolveGeocodingText(accessToken: string, text: string[], successFunc: (result: ApolusTypes.ResolvedGeocodingAddress[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new ResolveGeocodingTextMessageIn();
      InP.accessToken = accessToken;
      InP.text = text;
      this.SendRequest('ResolveGeocodingText', InP,
        function(content: object) {
          const data = content as ResolveGeocodingTextMessageOut;
          successFunc(data.ResolveGeocodingTextResult);
        },
        errorFunc
      );
    }

    public CreateRate(accessToken: string, description: string, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateRateMessageIn();
      InP.accessToken = accessToken;
      InP.description = description;
      this.SendRequest('CreateRate', InP,
        function(content: object) {
          const data = content as CreateRateMessageOut;
          successFunc(data.CreateRateResult);
        },
        errorFunc
      );
    }

    public CreateRates(accessToken: string, rates: ApolusTypes.Rate[], successFunc: (result: ApolusTypes.BulkRateCreation) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateRatesMessageIn();
      InP.accessToken = accessToken;
      InP.rates = rates;
      this.SendRequest('CreateRates', InP,
        function(content: object) {
          const data = content as CreateRatesMessageOut;
          successFunc(data.CreateRatesResult);
        },
        errorFunc
      );
    }

    public DeleteRate(accessToken: string, rateID: number, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new DeleteRateMessageIn();
      InP.accessToken = accessToken;
      InP.rateID = rateID;
      this.SendRequest('DeleteRate', InP,
        function(content: object) {
          const data = content as DeleteRateMessageOut;
          successFunc(data.DeleteRateResult);
        },
        errorFunc
      );
    }

    public EditRate(accessToken: string, rate: ApolusTypes.Rate, successFunc: (result: ApolusTypes.Rate) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EditRateMessageIn();
      InP.accessToken = accessToken;
      InP.rate = rate;
      this.SendRequest('EditRate', InP,
        function(content: object) {
          const data = content as EditRateMessageOut;
          successFunc(data.EditRateResult);
        },
        errorFunc
      );
    }

    public EnumRateByIDs(accessToken: string, rateIDs: number[], successFunc: (result: ApolusTypes.Rate[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumRateByIDsMessageIn();
      InP.accessToken = accessToken;
      InP.rateIDs = rateIDs;
      this.SendRequest('EnumRateByIDs', InP,
        function(content: object) {
          const data = content as EnumRateByIDsMessageOut;
          successFunc(data.EnumRateByIDsResult);
        },
        errorFunc
      );
    }

    public EnumRates(accessToken: string, successFunc: (result: ApolusTypes.Rate[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumRatesMessageIn();
      InP.accessToken = accessToken;
      this.SendRequest('EnumRates', InP,
        function(content: object) {
          const data = content as EnumRatesMessageOut;
          successFunc(data.EnumRatesResult);
        },
        errorFunc
      );
    }

    public GetRate(accessToken: string, rateID: number, successFunc: (result: ApolusTypes.Rate) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new GetRateMessageIn();
      InP.accessToken = accessToken;
      InP.rateID = rateID;
      this.SendRequest('GetRate', InP,
        function(content: object) {
          const data = content as GetRateMessageOut;
          successFunc(data.GetRateResult);
        },
        errorFunc
      );
    }

    public HideRate(accessToken: string, rateID: number, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new HideRateMessageIn();
      InP.accessToken = accessToken;
      InP.rateID = rateID;
      this.SendRequest('HideRate', InP,
        function(content: object) {
          const data = content as HideRateMessageOut;
          successFunc(data.HideRateResult);
        },
        errorFunc
      );
    }

    public CreateSector(accessToken: string, description: string, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateSectorMessageIn();
      InP.accessToken = accessToken;
      InP.description = description;
      this.SendRequest('CreateSector', InP,
        function(content: object) {
          const data = content as CreateSectorMessageOut;
          successFunc(data.CreateSectorResult);
        },
        errorFunc
      );
    }

    public CreateSectors(accessToken: string, sectors: ApolusTypes.Sector[], successFunc: (result: ApolusTypes.BulkSectorCreation) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new CreateSectorsMessageIn();
      InP.accessToken = accessToken;
      InP.sectors = sectors;
      this.SendRequest('CreateSectors', InP,
        function(content: object) {
          const data = content as CreateSectorsMessageOut;
          successFunc(data.CreateSectorsResult);
        },
        errorFunc
      );
    }

    public DeleteSector(accessToken: string, sectorID: number, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new DeleteSectorMessageIn();
      InP.accessToken = accessToken;
      InP.sectorID = sectorID;
      this.SendRequest('DeleteSector', InP,
        function(content: object) {
          const data = content as DeleteSectorMessageOut;
          successFunc(data.DeleteSectorResult);
        },
        errorFunc
      );
    }

    public EditSector(accessToken: string, sector: ApolusTypes.Sector, successFunc: (result: ApolusTypes.Sector) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EditSectorMessageIn();
      InP.accessToken = accessToken;
      InP.sector = sector;
      this.SendRequest('EditSector', InP,
        function(content: object) {
          const data = content as EditSectorMessageOut;
          successFunc(data.EditSectorResult);
        },
        errorFunc
      );
    }

    public EnumSectorByIDs(accessToken: string, sectorIDs: number[], successFunc: (result: ApolusTypes.Sector[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumSectorByIDsMessageIn();
      InP.accessToken = accessToken;
      InP.sectorIDs = sectorIDs;
      this.SendRequest('EnumSectorByIDs', InP,
        function(content: object) {
          const data = content as EnumSectorByIDsMessageOut;
          successFunc(data.EnumSectorByIDsResult);
        },
        errorFunc
      );
    }

    public EnumSectors(accessToken: string, successFunc: (result: ApolusTypes.Sector[]) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new EnumSectorsMessageIn();
      InP.accessToken = accessToken;
      this.SendRequest('EnumSectors', InP,
        function(content: object) {
          const data = content as EnumSectorsMessageOut;
          successFunc(data.EnumSectorsResult);
        },
        errorFunc
      );
    }

    public GetSector(accessToken: string, sectorID: number, successFunc: (result: ApolusTypes.Sector) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new GetSectorMessageIn();
      InP.accessToken = accessToken;
      InP.sectorID = sectorID;
      this.SendRequest('GetSector', InP,
        function(content: object) {
          const data = content as GetSectorMessageOut;
          successFunc(data.GetSectorResult);
        },
        errorFunc
      );
    }

    public HideSector(accessToken: string, sectorID: number, successFunc: (result: number) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new HideSectorMessageIn();
      InP.accessToken = accessToken;
      InP.sectorID = sectorID;
      this.SendRequest('HideSector', InP,
        function(content: object) {
          const data = content as HideSectorMessageOut;
          successFunc(data.HideSectorResult);
        },
        errorFunc
      );
    }

    public GetMasterEntityContent(accessToken: string, clientID: number, entityType: ApolusTypes.ApolusMasterEntityType, successFunc: (result: CoreTypes.MasterEntityDataContent) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new GetMasterEntityContentMessageIn();
      InP.accessToken = accessToken;
      InP.clientID = clientID;
      InP.entityType = entityType;
      this.SendRequest('GetMasterEntityContent', InP,
        function(content: object) {
          const data = content as GetMasterEntityContentMessageOut;
          successFunc(data.GetMasterEntityContentResult);
        },
        errorFunc
      );
    }

    public GetDashboard(accessToken: string, facilityID: number, adminArea2: number | null, sectorID: number | null, rateID: number | null, fromDateTime: CoreTypes.DateTimeDT, toDateTime: CoreTypes.DateTimeDT, successFunc: (result: ApolusTypes.Dashboard) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new GetDashboardMessageIn();
      InP.accessToken = accessToken;
      InP.facilityID = facilityID;
      InP.adminArea2 = adminArea2;
      InP.sectorID = sectorID;
      InP.rateID = rateID;
      InP.fromDateTime = fromDateTime;
      InP.toDateTime = toDateTime;
      this.SendRequest('GetDashboard', InP,
        function(content: object) {
          const data = content as GetDashboardMessageOut;
          successFunc(data.GetDashboardResult);
        },
        errorFunc
      );
    }

    public GetUserDashboard(accessToken: string, contractID: number, fromDateTime: CoreTypes.DateTimeDT, toDateTime: CoreTypes.DateTimeDT, successFunc: (result: ApolusTypes.UserDashboard) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new GetUserDashboardMessageIn();
      InP.accessToken = accessToken;
      InP.contractID = contractID;
      InP.fromDateTime = fromDateTime;
      InP.toDateTime = toDateTime;
      this.SendRequest('GetUserDashboard', InP,
        function(content: object) {
          const data = content as GetUserDashboardMessageOut;
          successFunc(data.GetUserDashboardResult);
        },
        errorFunc
      );
    }

    public GetApolusLiterals(accessToken: string, successFunc: (result: ApolusTypes.ApolusCommonLiterals) => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new GetApolusLiteralsMessageIn();
      InP.accessToken = accessToken;
      this.SendRequest('GetApolusLiterals', InP,
        function(content: object) {
          const data = content as GetApolusLiteralsMessageOut;
          successFunc(data.GetApolusLiteralsResult);
        },
        errorFunc
      );
    }

    public DataTypesDummy(p1: ApolusTypes.ApolusMenuHierarchyItem, p2: ApolusTypes.ApolusCommonLiterals, successFunc: () => void, errorFunc: (exception: ServiceException) => void): void {
      const InP = new DataTypesDummyMessageIn();
      InP.p1 = p1;
      InP.p2 = p2;
      this.SendRequest('DataTypesDummy', InP,
        function(content: object) {
          successFunc();
        },
        errorFunc
      );
    }

  }
}
